// frontend/src/features/livestock/imageSize.ts
export type ImageSize = 'thumbnail' | 'medium' | 'full';

const STORAGE_KEY = 'rdh-timeline-image-size';
/** Tank Shots keeps its own size: a big grid of the tank, small organism photos. */
export const TANK_SHOTS_IMAGE_SIZE_KEY = 'rdh-tank-shots-image-size';
const VALID_SIZES: ImageSize[] = ['thumbnail', 'medium', 'full'];
const DEFAULT_SIZE: ImageSize = 'medium';

export const IMAGE_SIZES: { value: ImageSize; label: string }[] = [
  { value: 'thumbnail', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'full', label: 'Large' },
];

export function getStoredImageSize(key: string = STORAGE_KEY): ImageSize {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(key);
  } catch {
    // Storage blocked (private mode): the default size.
  }
  if (stored && VALID_SIZES.includes(stored as ImageSize)) {
    return stored as ImageSize;
  }
  return DEFAULT_SIZE;
}

export function setStoredImageSize(size: ImageSize, key: string = STORAGE_KEY): void {
  try {
    localStorage.setItem(key, size);
  } catch {
    // Storage blocked: the size lasts until the page is left.
  }
}
